export default {
  title: 'Aflevertijd bijwerken',
  labels: {
    dropoff_time: 'Aflevertijd',
    confirmed: 'Bevestigde tijd:',
    new_time: 'Nieuwe tijd:',
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    success: 'Aflevertijd is succesvol bijgewerkt',
    failed_to_save: 'Opslaan van wijzigingen mislukt',
  },
  alerts: {
    dropoff_time_info: 'Zowel de huidige als de nieuwe tijd zijn in tijdzone {{timezone}} van {{restaurantName}}',
  },
};
